var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "supsisRightModal",
      class: [_vm.closed && "closed"],
      style: { width: _vm.width, zIndex: _vm.zIndex },
      attrs: { id: "supsis-right-modal" },
    },
    [
      _c("div", { staticClass: "close-modal", on: { click: _vm.closeModal } }, [
        _c("div", { staticClass: "material-icons" }, [_vm._v("close")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "head" }, [
        _vm.type === "editor-task"
          ? _c(
              "div",
              {
                staticClass: "title",
                attrs: { contenteditable: "true" },
                on: { input: _vm.updateTitle },
              },
              [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]
            )
          : _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _vm._v(_vm._s(_vm.description)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _vm.type === "create-task"
                ? _c("CreateTaskForm", {
                    on: { "update-form": _vm.updateForm },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "create-workflow"
                ? _c("WorkflowForm", { on: { "update-form": _vm.updateForm } })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "task-settings"
                ? _c("TaskSettings", { on: { "update-form": _vm.updateForm } })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "editor-task"
                ? _c("EditorTask", {
                    attrs: { details: _vm.details },
                    on: { "update-form": _vm.updateForm },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "edit-task"
                ? _c("CreateTaskForm", {
                    attrs: { details: _vm.details },
                    on: { "update-form": _vm.updateForm },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "pipeline-edit"
                ? _c("PipelineStageForm", {
                    attrs: { details: _vm.details },
                    on: { "update-form": _vm.updateForm },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "edit-workflow"
                ? _c("WorkflowForm", {
                    attrs: { details: _vm.details },
                    on: { "update-form": _vm.updateForm },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.footer
        ? _c("div", { staticClass: "footer" }, [
            _c(
              "div",
              {
                staticClass: "classic-submit-button",
                on: {
                  click: function ($event) {
                    return _vm.saveChanges(_vm.type)
                  },
                },
              },
              [_vm._v("Save Changes")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "classic-submit-button",
                attrs: { type: "normal" },
                on: { click: _vm.closeModal },
              },
              [_vm._v("Cancel")]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }